module.exports = __webpack_public_path__ + "img/image_9.648c5d1e.png";